module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-cara-corian-all.1d23a930.jpg";